import React, { Component } from "react";
import { Button, Form, Grid, Header, Segment, Message } from "semantic-ui-react";

import { connect } from "react-redux";
import { push } from "connected-react-router";
import { UPDATE_FIELD_AUTH, LOGIN_PAGE_UNLOADED, CLEAR_AUTH_ERRORS } from "../actions";
import { loginWithCredentials } from "../actions/auth.actions";
import AuthTokenService from "../services/auth-token.service";
import "./Login.css";

class Login extends Component {
  submitForm = (email, password) => ev => {
    ev.preventDefault();
    this.props.onSubmit(email, password);
  };

  componentWillMount() {
    if (AuthTokenService.get()) return this.props.redirectToHome();
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  errorHeader = errors => (
    <Message compact negative onDismiss={this.props.onErrorDismiss} as={Form.Field} width={11}>
      <Message.Header>Login failed</Message.Header>
      {errors.map((error, key) => (
        <p key={key}>{error.title}</p>
      ))}
    </Message>
  );

  render() {
    const { email = "", password = "", errors } = this.props;
    return (
      <Grid stretched className="app-page login">
        <Grid.Column width={10} className="login-bg" />
        <Grid.Column width={6} textAlign="left" verticalAlign="middle">
          <Segment basic textAlign="left" padded="very">
            <Header as="h1">Log in</Header>

            <Form size="small" onSubmit={this.submitForm(email, password)}>
              {errors && this.errorHeader(errors)}
              <Form.Input
                width={11}
                icon="mail"
                placeholder="E-mail address"
                required
                value={email}
                onChange={e => this.props.onChangeAuthField("email", e.target.value)}
              />

              <Form.Input
                width={11}
                icon="lock"
                placeholder="Password"
                type="password"
                required
                value={password}
                onChange={e => this.props.onChangeAuthField("password", e.target.value)}
              />

              <Segment basic />
              <Button color="orange">Log in</Button>
            </Form>
          </Segment>
        </Grid.Column>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  ...state.auth
});
const mapDispatchToProps = dispatch => ({
  redirectToHome: () => dispatch(push("/")),
  onSubmit: (email, password) => dispatch(loginWithCredentials(email, password)),
  onChangeAuthField: (key, value) => dispatch({ type: UPDATE_FIELD_AUTH, key, value }),
  onUnload: () => dispatch({ type: LOGIN_PAGE_UNLOADED }),
  onErrorDismiss: () => dispatch({ type: CLEAR_AUTH_ERRORS })
});
export default connect(mapStateToProps, mapDispatchToProps)(Login);
